var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTownhouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.685 29.636c0 4.924 0 4.924 4.516 4.924 4.61 0 4.61 0 4.61-4.552 0-4.46 0-4.46-4.234-4.46-4.892.093-4.892.093-4.892 4.088zm28.975 0c0 4.924 0 4.924 4.515 4.924 4.61 0 4.61 0 4.61-4.552 0-4.46 0-4.46-4.234-4.46-4.892.093-4.892.093-4.892 4.088zm22.765 27.22h-1.6V23.413c0-.744-.376-1.58-.94-2.044L52.398 9.105c-1.035-.837-2.54-.837-3.48 0L36.781 19.324 24.27 8.826c-1.034-.836-2.54-.836-3.48 0L6.114 21.089c-.564.465-.94 1.3-.94 2.044V56.95h-1.6c-.846 0-1.505.65-1.505 1.486v2.694c0 .837.659 1.487 1.505 1.487H69.52c.847 0 1.505-.65 1.505-1.487v-2.694c0-.836-.752-1.58-1.599-1.58zm-34.995-.092h-7.714v-9.94c0-1.116-1.129-2.045-2.446-2.045h-4.139c-1.41 0-2.446.93-2.446 2.044v9.848h-7.15v-32.33L22.39 14.307l11.947 10.034v32.423h.094zm28.034 0h-6.68v-9.94c0-1.116-1.128-2.045-2.445-2.045h-4.14c-1.41 0-2.445.93-2.445 2.044v9.848H39.04V24.434l11.665-9.755 11.853 9.94v32.145h-.094z",
    fill: "current"
  })));
}

export default SvgIconTownhouse;